// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import * as api from '@src/api/ChatApi'
import moment from 'moment'

// ** Axios Imports
import axios from 'axios'
import {
  getAllEmailPersonal,
  getCurrentEmailPersonal,
  updateEmailLabel,
  deleteEmails,
  getEmailSearchResults,
} from '@src/api/ChatEmailApi'

import { toast } from 'react-toastify'

// createAsyncThunk('appChat/getChats', async (campaign_id) =>

export const getMails = createAsyncThunk(
  'personalEmail/getMails',
  async (
    { folder_name, setNewDataLoaded, next_page_token, pageIdx },
    { rejectWithValue },
  ) => {
    try {
      const response = await getAllEmailPersonal(folder_name, next_page_token)
      setNewDataLoaded(true)
      console.log('personalEmail/getMails: ', folder_name, response)
      return {
        Data: response.data.Data,
        folder_name: folder_name,
        pageIdx: pageIdx,
      }
    } catch (error) {
      setNewDataLoaded(true)
      console.log('DEBUG: INSIDE ERROR', error, error.message, error.response)
      toast.error(
        error?.response?.data?.Message ??
          'Something went wrong, please try again',
      )
      return rejectWithValue(error)
    }
  },
)

export const searchMails = createAsyncThunk(
  'personalEmail/searchMails',
  async (
    { query, folder_name, start, end, setNewDataLoaded },
    { rejectWithValue },
  ) => {
    try {
      const response = await getEmailSearchResults(
        query,
        start,
        end,
        folder_name,
      )
      setNewDataLoaded(true)
      return { Data: response.data.Data, folder_name: folder_name }
    } catch (error) {
      setNewDataLoaded(true)
      return rejectWithValue(error)
    }
  },
)

export const clearAllEmails = createAsyncThunk(
  'personalEmail/clearMails',
  async ({}, { rejectWithValue }) => {
    console.log('clearAllEmails ')
    return { Data: [], folder_name: '' }
  },
)

export const updateMails = createAsyncThunk(
  'personalEmail/updateMails',
  async ({ emailIds, dataToUpdate }, { dispatch, getState }) => {
    const response = await axios.post('/apps/email/update-emails', {
      emailIds,
      dataToUpdate,
    })
    // await dispatch(getMails(getState().email.params))
    return {
      emailIds,
      dataToUpdate,
      data: response.data,
    }
  },
)

export const updateMailLabel = createAsyncThunk(
  'personalEmail/updateMailLabel',
  async ({ emailID, label }, { dispatch, getState }) => {
    const response = await updateEmailLabel(emailID, label)
    if (response.data.Response !== 'Ok') return []
    let mails = getState().email.mails
    console.log('UpdatedMails', mails)
    let data = response.data.Data
    let index = -1
    mails.map((e, pos) => {
      if (e.id === data.id) {
        index = pos
      }
    })
    console.log('UpdatedMails', index)
    // TODO: now working, here crashing
    let mail = mails[index]
    mail.label = data.label
    console.log('UpdatedMails mail', mail)
    console.log('UpdatedMails final', mails)
    return mails
  },
)

export const paginateMail = createAsyncThunk(
  'personalEmail/paginateMail',
  async ({ dir, emailId }) => {
    const response = await axios.get('/apps/email/paginate-email', {
      params: { dir, emailId },
    })
    return response.data
  },
)

export const selectCurrentMail = createAsyncThunk(
  'personalEmail/selectCurrentMail',
  async ({ id }, { rejectWithValue }) => {
    try {
      console.log('DEBUG Store ', id)
      const response = await getCurrentEmailPersonal(id)
      console.log('personalEmail/getMails111: ', response)
      // setEmailDetailLoaded(true);
      return { Data: response.data.Data }
    } catch (error) {
      // setEmailDetailLoaded(true);
      return rejectWithValue(error)
    }
  },
)

export const deleteMails = createAsyncThunk(
  'personalEmail/deleteMails',
  async ({ emailIds, dataToUpdate }, { rejectWithValue }) => {
    try {
      const response = await deleteEmails(emailIds, dataToUpdate)
      console.log('personalEmail/getMails: ', emailIds, dataToUpdate)
      return { Data: emailIds }
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const personalEmailSlice = createSlice({
  name: 'personalEmail',
  initialState: {
    mails: {},
    params: {},
    emailsMeta: {},
    selectedMails: [],
    currentMail: null,
    folder: '',
    last_fetch_time: {},
    result_size_estimate: {},
    tokens: {},
  },
  reducers: {
    selectMail: (state, action) => {
      const selectedMails = state.selectedMails
      if (!selectedMails.includes(action.payload)) {
        selectedMails.push(action.payload)
      } else {
        selectedMails.splice(selectedMails.indexOf(action.payload), 1)
      }
      state.selectedMails = selectedMails
      console.log('STORE: DISPATCH SELECT MAIL ', action.payload)
    },
    updateTokens: (state, action) => {},
    selectAllMail: (state, action) => {
      // const selectAllMailsArr = []
      // if (action.payload) {
      //   selectAllMailsArr.length = 0
      //   state.mails.forEach(mail => selectAllMailsArr.push(mail.id))
      // } else {
      //   selectAllMailsArr.length = 0
      // }
      // state.selectedMails = selectAllMailsArr
    },
    updateFolder: (state, action) => {
      console.log('UPDATE FOLDER', action.payload)
      let folder = action.payload
      state.folder = folder
      state.tokens[folder] = {
        0: '',
      }
      state.result_size_estimate[folder] = 0
      console.log('UPDATE FOLDER', action.payload)
    },
    resetSelectedMail: (state) => {
      state.selectedMails = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMails.fulfilled, (state, action) => {
        console.log('UpdatedMails from reducer', action.payload)

        var folder_name = action?.payload?.folder_name ?? ''
        var data = action?.payload?.Data ?? {}
        var threads = data?.threads ?? []
        var token = data?.next_page_token ?? ''
        var result_size_estimate = data?.result_size_estimate ?? 0
        var pageIdx = action.payload.pageIdx

        if (folder_name.length == 0) {
          return
        }

        //

        state.mails[folder_name] = threads
        state.result_size_estimate[folder_name] = result_size_estimate

        let existing_token = state.tokens[folder_name]
        console.log('DEBUG: key', state.tokens, folder_name, existing_token)

        state.tokens[folder_name][pageIdx + 1] = token

        state.folder = folder_name
        state.last_fetch_time[folder_name] = Date()
      })
      .addCase(getMails.rejected, (state, action) => {
        console.log('UpdatedMails from reducer', action)

        // state.mails["Inbox"] = [];
        // state.folder = "Inbox";
        state.last_fetch_time['Inbox'] = Date()
      })
      .addCase(searchMails.fulfilled, (state, action) => {
        console.log('UpdatedMails from reducer', action.payload)

        state.mails[action.payload.folder_name] = action.payload.Data
        state.last_fetch_time[action.payload.folder_name] = Date()
      })
      .addCase(searchMails.rejected, (state, action) => {
        console.log('UpdatedMails from reducer', action)

        state.mails['Inbox'] = []
        state.last_fetch_time['Inbox'] = Date()
      })
      .addCase(clearAllEmails.fulfilled, (state, action) => {
        console.log('UpdatedMails from reducer', action)
        state.mails = {}
        state.folder = ''
        state.emailsMeta = {}
        state.selectedMails = []
        state.currentMail = null
        state.last_fetch_time = {}
      })
      .addCase(clearAllEmails.rejected, (state, action) => {
        console.log('UpdatedMails from reducer', action)
        state.mails = {}
        state.folder = ''
        state.emailsMeta = {}
        state.selectedMails = []
        state.currentMail = null
        state.last_fetch_time = {}
      })
      .addCase(deleteMails.fulfilled, (state, action) => {
        let newData = [...state.mails[state.folder]].filter((k) => {
          console.log(
            'UpdatedMails from reducer0',
            action.payload.Data.includes(k[0].uid),
          )
          if (action.payload.Data.includes(k.uid)) {
            return false
          } else {
            return true
          }
        })
        console.log('UpdatedMails from reducer', action, newData)
        state.mails[state.folder] = newData
        state.last_fetch_time[state.folder] = Date()
      })
      .addCase(deleteMails.rejected, (state, action) => {
        console.log('UpdatedMails from reducer', action)
        state.last_fetch_time[state.folder] = Date()
      })
      .addCase(updateMailLabel.fulfilled, (state, action) => {
        console.log('UpdatedMails from reducer', action.payload)
        if (action.payload.length !== 0) {
          state.mails = action.payload
        }
      })
      .addCase(updateMails.fulfilled, (state, action) => {})
      .addCase(paginateMail.fulfilled, (state, action) => {
        // const data = action.payload
        // const dataIndex = state.mails.findIndex(i => i.id === data.id)
        // dataIndex === 0 ? (data.hasPreviousMail = false) : (data.hasPreviousMail = true)
        // dataIndex === state.mails.length - 1 ? (data.hasNextMail = false) : (data.hasNextMail = true)
        // state.currentMail = data
      })
      .addCase(selectCurrentMail.fulfilled, (state, action) => {
        //CURRENT DETAILS
        state.currentMail = action.payload.Data[0]
      })
  },
})

export const { selectMail, selectAllMail, resetSelectedMail, updateFolder } =
  personalEmailSlice.actions

export default personalEmailSlice.reducer
